/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Wh_ScentingInputs */

const vi_sinp_wh_scenting = /** @type {(inputs: Sinp_Wh_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho lấy hương`)
};

/**

* @param {Sinp_Wh_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_wh_scenting = /** @type {((inputs?: Sinp_Wh_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Wh_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_wh_scenting(inputs)
});